export default "__VITE_ASSET__RYJt6clg__"